module.exports = __webpack_public_path__ + "img/stock.6395c12a.png";